<!-- Filter Datatables -->
<section id="ngx-datatable-filter">
    <div class="row">
        <div class="col-12"></div>
        <div class="col-12">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <!-- ngx-datatable-filter -->
                        <fieldset class="form-group">
                            <div class="row">
                                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                                    <!-- <div class="btn-group enrollment-list-btn-info" role="group">
                                        <button class="btn enrollment-list-buttons cursor-pointer" type="button" *ngFor="let status of type_List"
                                            [ngClass]="{'btn-primary':activeTab==status?.name,'btn-outline-primary':activeTab!=status?.name}"
                                            (click)="activeEmployeeTab(status?.name)">{{status.displayname}}</button>
                                    </div> -->
                                    <div class="col-12">
                                        <button *ngIf="guideline_data" class="btn btn-outline-primary" (click)="openDynamicModal(guideline_data)">Company Guideline</button>
                                      </div>
                                </div>
                                <div class="col-12 col-sm-12 col-md-6 col-lg-6 mb-1">
                                    <!-- <div class="row-flex">
                                        <div class="col-flex-2 mb-1">
                                            <label for="ngx-filter-ref">Search:
                                                <input id="ngx-filter-ref"
                                                    class="form-control form-control-sm d-inline-block width-200 ml-1"
                                                    type="text" (keyup)="getContactFilter($event)" />
                                            </label>
                                        </div>
                                        <div class="col-flex-2 mb-1"
                                            *ngIf=" user_role.roles =='admin' || user_role.roles =='employee' || user_role.roles =='extractor'">
                                            <button type="reset"
                                                class="btn btn-primary btn-block users-list-clear glow mb-0"
                                                routerLink="/contact/add">
                                                Add
                                            </button>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </fieldset>
                        <ngx-datatable class="bootstrap core-bootstrap" [columnMode]="ColumnMode.force"
                            [headerHeight]="50" [footerHeight]="50" rowHeight="auto" [limit]="limitRef" [rows]="rows"
                            [scrollbarH]="true" [columns]="columns" [externalPaging]="true" [count]="page.totalPages"
                            [offset]="page.offset" (page)="pageChangeData($event)">
                            <ngx-datatable-column name="Name" prop="name" [width]="50">
                                <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                                    <div class="d-flex align-items-center">
                                        <div class="cell-line-height cursor-pointer"
                                            (click)="openModalUpdate(myModal,row?._id,row.name)">
                                            <p class="font-medium-1 line-height-1 mb-0">
                                                {{ row.name }}
                                            </p>
                                        </div>
                                    </div>
                                </ng-template>
                            </ngx-datatable-column>

                            <ngx-datatable-column name="Email" prop="email" [width]="70"></ngx-datatable-column>
                            <ngx-datatable-column name="Phone" prop="phone" [width]="70"></ngx-datatable-column>
                            <ngx-datatable-column name="Business" prop="business_id" [width]="70">
                                <ng-template let-row="row" ngx-datatable-cell-template>
                                    <p class="d-flex" *ngFor="let type of row?.type; let isLast = last">
                                        <span>
                                            {{type?.displayname}}
                                            <span *ngIf=" !isLast">,</span>
                                        </span>
                                    </p>
                                </ng-template>
                            </ngx-datatable-column>

                        </ngx-datatable>
                        <!-- ngx-datatable-filter -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!--/ Filter Datatables -->
<div class="d-flex justify-content-between align-items-center">
    <ngx-spinner></ngx-spinner>
</div>

<!-- ---------- -->

<!----- -->
<div>
    <ng-template #myModal let-modal>
        <div class="modal-header">
            <h4 class="modal-title">Contacts for {{row_name}}</h4>

            <button type="button" class="close" (click)="modal.dismiss()">
                <span>&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <ngx-datatable [rows]="contact_data" [rowHeight]="50" class="bootstrap core-bootstrap" [limit]="10"
                [columnMode]="ColumnMode.force" [headerHeight]="50" [footerHeight]="50" [scrollbarH]="true">
                <ngx-datatable-column name="Name" prop="name" [width]="50">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                        <div class="d-flex align-items-center">
                            {{row?.name}}
                        </div>
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Email" prop="email" [width]="30">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                        {{row?.email }}
                    </ng-template>
                </ngx-datatable-column>
                <ngx-datatable-column name="Phone" prop="phone" [width]="10">
                    <ng-template let-row="row" let-name="value" ngx-datatable-cell-template>
                        <span>{{row?.phone}}</span>
                    </ng-template>
                </ngx-datatable-column>

            </ngx-datatable>

        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" (click)="modalService.dismissAll()">Cancel</button>
        </div>
    </ng-template>
</div>

